module.exports = __webpack_public_path__ + "img/icon-message.416e9cb4.svg";